import { Component, h } from '@stencil/core';
import store, { SuggestionFund } from '../store';

@Component({
  tag: 'ui-download-search-funds-box',
  styleUrl: 'ui-download-search-funds-box.scss',
  shadow: true,
})
export class UiDownloadSearchFundsBox {
  private removeFund = (fund: SuggestionFund) => {
    store.state.selectedFunds = store.state.selectedFunds.filter(
      (selectedFund) => selectedFund.isin !== fund.isin
    );
  };

  render() {
    return (
      <ui-container variant="primary100">
        <ui-table firstColumnFixed={false} firstRowAsHeader={true}>
          <table>
            <thead>
              <tr>
                <th>Fondsname</th>
                <th>ISIN</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {store.state.selectedFunds.map((fund) => (
                <tr key={fund.isin}>
                  <td>{fund.fondsname}</td>
                  <td>{fund.isin}</td>
                  <td>
                    <ui-button
                      icon="trash"
                      variant="plain"
                      onClick={() => this.removeFund(fund)}
                    ></ui-button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </ui-table>
        <div class="remove-all">
          <ui-button
            class="remove-all"
            variant="plain"
            icon="trash"
            onClick={() => {
              store.state.selectedFunds = [];
            }}
          >
            Alle entfernen
          </ui-button>
        </div>
      </ui-container>
    );
  }
}
